import { gql } from "@apollo/client";

export const SKIP_MODERATOR_ANSWER = gql`
  mutation SkipModeratorAnswer($answer: ID!) {
    skipModeratorAnswer(answer: $answer) {
      success
      message
    }
  }
`;

export const SUBMIT_MODERATOR_FEEDBACK = gql`
  mutation SubmitModeratorFeedback(
    $answer: ID!
    $aoMarks: JSONString!
    $feedback: String
    $areasToImprove: String
  ) {
    submitModeratorFeedback(
      answer: $answer
      aoMarks: $aoMarks
      feedback: $feedback
      areasToImprove: $areasToImprove
    ) {
      success
      message
      answer {
        id
        moderatorFeedback {
          id
          mark
          feedback
          specificAreasOfImprovement
          approvedBy {
            id
            firstName
            lastName
          }
          approvedAt
        }
      }
    }
  }
`;
